import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { of } from 'rxjs';
import { ListService } from '@fry/lib/list';
import { BookingTypesSearch, BookingTypesStore } from '@fry/booking/lib/booking-types';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';


@Component({
    selector: 'eas-booking-type-list',
    templateUrl: './booking-type-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BookingTypeListComponent implements OnInit, OnDestroy {

  public items = this.list.items;
  public actions: EASLinkAction[] = [{
    type: 'link',
    label: $localize `New booking item type`,
    condition: () => {
      return of(true);
    },
    link: of(['add']),
    color: 'primary',
  }];


  constructor(
    private store: BookingTypesStore,
    private search: BookingTypesSearch,
    private list: ListService
  ) { }

  ngOnInit() {
    this.list.setupWith(this.store, this.search).subscribe();
  }

  ngOnDestroy() {
  }

}
